import React from "react";
import { Route, Switch } from "react-router-dom";

import "./App.scss";

// component imports
import DashMenu from "./components/DashMenu/dashMenu.component";
import NavMenu from "./components/NavMenu/navmenu.component";
import Player from "./pages/playerpage/playerpage.component";

// page imports
import Home from "./pages/homepage/homepage.component";
import Capture from "./pages/capture";
import Favorites from "./pages/favoritespage/favorites.component";
import Documents from "./pages/documents";
import Recent from "./pages/recent";
import NotFound from "./pages/notFound";

// misc import
import data from "./components/NewsTile/tileData";

function App() {
  return (
    <div className="App">
      <DashMenu />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/capture" component={Capture} />
        <Route exact path="/recent" component={Recent} />
        <Route exact path="/favorites" component={Favorites} />
        <Route exact path="/docs" component={Documents} />
        <Route
          exact
          path="/feeds/:category/:id"
          render={({ match }) => (
            <Player
              feed={data[match.params.category].find(
                (d) => d.id === parseInt(match.params.id)
              )}
            />
          )}
        />
        <Route exact path="/player" component={Player} />
        <Route exact path="/*" component={NotFound} />
      </Switch>
      <center>
        <br />
        <NavMenu />
      </center>
    </div>
  );
}

export default App;
